import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import history from '../../history';
import cx from 'classnames';
// external-global styles must be imported in your JS.
import normalizeCss from 'normalize.css';
import SideMenu from '../SideMenu/SideMenu';
import AdminHeader from '../AdminHeader/AdminHeader';
import Toaster from '../Toaster';
import OffcanvasMenu from '../SideMenu/MobileSideBar/OffcanvasMenu';
import s from './AdminLayout.css';

function AdminLayout({ children }) {

  // For Highlighting Side Menu based on URL
  const location = history.location?.pathname;

  return (
    <div className="bodyOverflow rtlLoader">
      <Toaster />
      <AdminHeader />
      <aside className={cx(s.sideMenuContainer, "hidden-print")}>
        <div className={cx(s.sideMenuWrapper, 'sideMenuWrapperRtl')}>
          <SideMenu location={location} />
        </div>
      </aside>
      <OffcanvasMenu location={location} />
      <main className={cx(s.mainContent, 'mainContentRTL', 'printBody')}>
        {children}
      </main>
    </div>
  );
}

AdminLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withStyles(normalizeCss, s)(AdminLayout);
